import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80e3e5e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crm-potential-card w-full" }
const _hoisted_2 = { class: "labels-list flex gap-4 max-w-[95%] overflow-x-scroll" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "mb-0 text-3xl" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "potential-assignees" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center"
}

import modernStatusChip from "@/components/reusable/modernStatusChip.vue"
import starDisplay from "@/components/reusable/starDisplay.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'potentialCard',
  props: ["potential", "buttonText", "buttonClick"],
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.potential.potentialCategories, (category) => {
        return (_openBlock(), _createBlock(modernStatusChip, {
          class: "!text-left !justify-start mb-8",
          key: category.id,
          text: category.name,
          bgColors: { [category.id]: category.color },
          value: category.id
        }, null, 8, ["text", "bgColors", "value"]))
      }), 128))
    ]),
    _createElementVNode("header", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(props.potential.title), 1),
      _createVNode(starDisplay, {
        "picked-quantity": __props.potential.potentialRating
      }, null, 8, ["picked-quantity"])
    ]),
    _createElementVNode("p", null, _toDisplayString(__props.potential.description), 1),
    _hoisted_5,
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.potential.assignedTo, (assignedTo) => {
        return (_openBlock(), _createElementBlock("li", {
          key: assignedTo.id
        }, [
          (assignedTo.profileImage && assignedTo.profileImage !== '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                referrerpolicy: "no-referrer",
                src: assignedTo.profileImage,
                alt: "Profile Image",
                class: "w-10 h-10 rounded-full"
              }, null, 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(assignedTo.userName.charAt(0)), 1)
              ]))
        ]))
      }), 128))
    ])
  ]))
}
}

})